
import React from 'react';
import GenericTableEditor from '../../components/admin/GenericTableEditor';

const JobOpeningsEditor = () => {
  const columns = [
    { key: 'title', label: 'Title (EN)', type: 'text' },
    { key: 'title-ms', label: 'Title (MS)', type: 'text' },
    { key: 'description', label: 'Description (EN)', type: 'textarea' },
    { key: 'description-ms', label: 'Description (MS)', type: 'textarea' },
    { key: 'time', label: 'Time (EN)', type: 'text' },
    { key: 'time-ms', label: 'Time (MS)', type: 'text' },
    { key: 'location', label: 'Location (EN)', type: 'text' },
    { key: 'location-ms', label: 'Location (MS)', type: 'text' },
    { key: 'category', label: 'Category (EN)', type: 'text' },
    { key: 'category-ms', label: 'Category (MS)', type: 'text' },
    { 
      key: 'status', 
      label: 'Active Status', 
      type: 'checkbox' 
    },
  ];

  return <GenericTableEditor tableName="job_openings" columns={columns} title="Job Openings Manager" />;
};

export default JobOpeningsEditor;
